import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { MentionListComponent } from './mention-list.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        MentionListComponent
    ],
    declarations: [
        MentionListComponent
    ]
})
export class MentionModule {
    static forRoot(): ModuleWithProviders<MentionModule> {
        return {
            ngModule: MentionModule
        };
    }
}
